import { Button, Input, Modal, Space } from 'antd';
import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { rootContext } from 'stores';

import './EditPatternType.scss';

const EditPatternType: React.FC = observer(() => {
  const {
    PatternStore: {
      updatePattern,
      state: {
        data,
        ui: { editPatternLoading }
      },
      setState
    }
  } = useContext(rootContext);

  const [pattern, setPattern] = useState<string>(
    data.editPatternData?.name || ''
  );

  const onCloseRegionModal = () => {
    setState({ data: { ...data, editPatternData: null } });
  };

  useEffect(() => {
    return () => {
      setPattern('');
    };
  }, [data.editPatternData]);

  return (
    <div className="EditregionStyles">
      <Modal
        title="Edit Pattern Type"
        footer={false}
        visible={data.editPatternData ? true : false}
        destroyOnClose={true}
        onCancel={onCloseRegionModal}
        afterClose={onCloseRegionModal}
      >
        <Space>
          <Input
            value={pattern || data.editPatternData?.name}
            onChange={e => setPattern(e.target.value)}
          />
          <Button
            type="primary"
            className="primary_btn"
            loading={Boolean(editPatternLoading)}
            onClick={() =>
              data.editPatternData &&
              updatePattern({
                id: data.editPatternData.id,
                name: pattern
              })
            }
          >
            Edit
          </Button>
        </Space>
      </Modal>
    </div>
  );
});

export default EditPatternType;
